import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { environment } from '../../../environment/environment';
import { Router } from '@angular/router';
import { ApiDataService } from '../../services/api.service';
import { ShService } from '../../services/sh-service';

@Component({
    selector: 'app-navbar',
    imports: [SharedModule],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {
  openDockLink = environment.externalUrls.openDock;
  pageTitle: string = '';
  userName: string = '';
  userRole: any = '';
  menus: any;
  isFullSidebar: boolean = false;
  currentProfile: number = -1;
  innerWidth: any;
  labels: any;
  currentLob: string = '';

  constructor(
    private router: Router,
    private _apiService: ApiDataService,
    private _service: ShService
  ){
    
  }

  ngOnInit(): void {
    this.currentLob = sessionStorage.getItem('currentLob') || 'Halloween'
    this.innerWidth = window.innerWidth;
    this.labels = JSON.parse(sessionStorage.getItem('labels') as any);

    if(this.innerWidth < 1600){
      this.isFullSidebar = false;
      this._service.isSmallScreen$.next(true);
      document.querySelector('body')?.classList.add('collapsed');
    }
    this.router.events.subscribe((events:any) => {
      this.pageTitle = this.router.url.split('/')[1];
    });

    this._service.isLoggedIn$.subscribe(x => {
      this.userName = sessionStorage.getItem('name') || '';
      this.userRole = sessionStorage.getItem('role')?.toLowerCase() || -1;
      this.userRole = parseInt(this.userRole);
      this.currentProfile = parseInt(sessionStorage.getItem('currentProfile') || '');

      this.menus = [
        {
          name: this.labels.menu.home,
          route: "dashboard",
          enable: true,
          icon: 'bi-house-door-fill'
        },
        {
          name: this.labels.menu.pallets,
          route: "pallets",
          enable: this.currentProfile === 1 || this.userRole === 2 || this.userRole === 3,
          icon: 'bi-layers'
        },
        {
          name: this.labels.menu.users,
          route: "users",
          enable: this.userRole < 3 || this.userRole === 99,
          icon: 'bi-people-fill'
        },
        {
          name: this.labels.menu.store,
          route: "store",
          enable: true,
          icon: 'bi-shop'
        },
        {
          name: this.labels.menu.org,
          route: "3pl",
          enable: this.userRole < 2 || this.userRole === 99,
          icon: 'bi-buildings-fill'
        },
        {
          name: this.labels.menu.reports,
          route: "reports",
          enable: true,
          icon: 'bi-clipboard-data-fill'
        },
        {
          name: this.labels.menu.support,
          route: "support",
          enable: this.userRole === 2 || this.userRole === 3,
          icon: 'bi-headset'
        },
        {
          name: this.labels.menu.transfer,
          route: "transfer",
          enable: this.userRole !== 3,
          icon: 'bi-rocket-takeoff',

        },
        {
          name: this.labels.menu.config,
          route: "configuration",
          enable: this.userRole === 99,
          icon: 'bi-gear'
        }
      ];
    }); 
  }

  toggle(){
    this.isFullSidebar = !this.isFullSidebar;
    this.isFullSidebar? document.querySelector('body')?.classList.remove('collapsed') : document.querySelector('body')?.classList.add('collapsed');
    this._service.toggleSidebar$.next(true);
  }
  getLogoPath(): string {
    if (this.currentLob === 'CHRISTMAS') {
      return this.isFullSidebar ? './img/xmas-big.png' : './img/xmas-small.png';
    }
    // Default to HALLOWEEN
    return this.isFullSidebar ? './img/new-logo.png' : './img/small-logo.png';
  }

  logout(){
    let userEmail = sessionStorage.getItem('email');
    const PAYLOAD = {
      userName: userEmail
    };
    this._apiService.logout(PAYLOAD).subscribe(x => {
      sessionStorage.clear();
      this.router.navigate(["/login"]);
    }, (error) => {
      alert(error.error.error);
    }, () => {});
  }
}
